export const FLAGS_UPDATED = 'app/modules/fwf/FLAGS_UPDATED';
